/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
var github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb = require('../../../../../../github.com/solo-io/dev-portal/api/dev-portal/v1beta1/common/common_pb.js');
var github_com_solo$io_solo$apis_api_gloo_gloo_v1_ssl_ssl_pb = require('../../../../../../github.com/solo-io/solo-apis/api/gloo/gloo/v1/ssl/ssl_pb.js');
var github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_pb = require('../../../../../../github.com/solo-io/solo-apis/api/gloo/gloo/v1/options_pb.js');
var github_com_solo$io_cue_encoding_protobuf_cue_cue_pb = require('../../../../../../github.com/solo-io/cue/encoding/protobuf/cue/cue_pb.js');
var extproto_ext_pb = require('../../../../../../extproto/ext_pb.js');
goog.exportSymbol('proto.portal.gloo.solo.io.CustomStyling', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.PageSpec', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.PortalSpec', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.PortalSpec.GatewayConfig', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.PortalSpec.OidcAuth', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.PortalSpec.PageExtension', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.PortalStatus', null, global);
goog.exportSymbol('proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.PortalSpec = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.portal.gloo.solo.io.PortalSpec.repeatedFields_, proto.portal.gloo.solo.io.PortalSpec.oneofGroups_);
};
goog.inherits(proto.portal.gloo.solo.io.PortalSpec, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.PortalSpec.displayName = 'proto.portal.gloo.solo.io.PortalSpec';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.portal.gloo.solo.io.PortalSpec.repeatedFields_ = [3,8,9,14];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.portal.gloo.solo.io.PortalSpec.oneofGroups_ = [[12,20]];

/**
 * @enum {number}
 */
proto.portal.gloo.solo.io.PortalSpec.LoginAuthCase = {
  LOGIN_AUTH_NOT_SET: 0,
  OIDC_AUTH: 12,
  OAUTH2_AUTH: 20
};

/**
 * @return {proto.portal.gloo.solo.io.PortalSpec.LoginAuthCase}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.getLoginAuthCase = function() {
  return /** @type {proto.portal.gloo.solo.io.PortalSpec.LoginAuthCase} */(jspb.Message.computeOneofCase(this, proto.portal.gloo.solo.io.PortalSpec.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.PortalSpec.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.PortalSpec} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.PortalSpec.toObject = function(includeInstance, msg) {
  var f, obj = {
    displayName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    domainsList: jspb.Message.getRepeatedField(msg, 3),
    primaryLogo: (f = msg.getPrimaryLogo()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.toObject(includeInstance, f),
    favicon: (f = msg.getFavicon()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.toObject(includeInstance, f),
    banner: (f = msg.getBanner()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.toObject(includeInstance, f),
    customStyling: (f = msg.getCustomStyling()) && proto.portal.gloo.solo.io.CustomStyling.toObject(includeInstance, f),
    staticPagesList: jspb.Message.toObjectList(msg.getStaticPagesList(),
    proto.portal.gloo.solo.io.PageSpec.toObject, includeInstance),
    dynamicPagesList: jspb.Message.toObjectList(msg.getDynamicPagesList(),
    proto.portal.gloo.solo.io.PageSpec.toObject, includeInstance),
    enableIngress: (f = msg.getEnableIngress()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    oidcAuth: (f = msg.getOidcAuth()) && proto.portal.gloo.solo.io.PortalSpec.OidcAuth.toObject(includeInstance, f),
    oauth2Auth: (f = msg.getOauth2Auth()) && proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.toObject(includeInstance, f),
    tls: (f = msg.getTls()) && github_com_solo$io_solo$apis_api_gloo_gloo_v1_ssl_ssl_pb.SslConfig.toObject(includeInstance, f),
    publishedEnvironmentsList: jspb.Message.toObjectList(msg.getPublishedEnvironmentsList(),
    proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.toObject, includeInstance),
    allApisPublicViewable: jspb.Message.getFieldWithDefault(msg, 15, false),
    portalUrlPrefix: jspb.Message.getFieldWithDefault(msg, 16, ""),
    gatewayConfig: (f = msg.getGatewayConfig()) && proto.portal.gloo.solo.io.PortalSpec.GatewayConfig.toObject(includeInstance, f),
    pageExtensionsMap: (f = msg.getPageExtensionsMap()) ? f.toObject(includeInstance, proto.portal.gloo.solo.io.PortalSpec.PageExtension.toObject) : [],
    routeOptions: (f = msg.getRouteOptions()) && github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_pb.RouteOptions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.PortalSpec}
 */
proto.portal.gloo.solo.io.PortalSpec.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.PortalSpec;
  return proto.portal.gloo.solo.io.PortalSpec.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.PortalSpec} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.PortalSpec}
 */
proto.portal.gloo.solo.io.PortalSpec.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addDomains(value);
      break;
    case 4:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.deserializeBinaryFromReader);
      msg.setPrimaryLogo(value);
      break;
    case 5:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.deserializeBinaryFromReader);
      msg.setFavicon(value);
      break;
    case 6:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.deserializeBinaryFromReader);
      msg.setBanner(value);
      break;
    case 7:
      var value = new proto.portal.gloo.solo.io.CustomStyling;
      reader.readMessage(value,proto.portal.gloo.solo.io.CustomStyling.deserializeBinaryFromReader);
      msg.setCustomStyling(value);
      break;
    case 8:
      var value = new proto.portal.gloo.solo.io.PageSpec;
      reader.readMessage(value,proto.portal.gloo.solo.io.PageSpec.deserializeBinaryFromReader);
      msg.addStaticPages(value);
      break;
    case 9:
      var value = new proto.portal.gloo.solo.io.PageSpec;
      reader.readMessage(value,proto.portal.gloo.solo.io.PageSpec.deserializeBinaryFromReader);
      msg.addDynamicPages(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEnableIngress(value);
      break;
    case 12:
      var value = new proto.portal.gloo.solo.io.PortalSpec.OidcAuth;
      reader.readMessage(value,proto.portal.gloo.solo.io.PortalSpec.OidcAuth.deserializeBinaryFromReader);
      msg.setOidcAuth(value);
      break;
    case 20:
      var value = new proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth;
      reader.readMessage(value,proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.deserializeBinaryFromReader);
      msg.setOauth2Auth(value);
      break;
    case 13:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_v1_ssl_ssl_pb.SslConfig;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_v1_ssl_ssl_pb.SslConfig.deserializeBinaryFromReader);
      msg.setTls(value);
      break;
    case 14:
      var value = new proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector;
      reader.readMessage(value,proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.deserializeBinaryFromReader);
      msg.addPublishedEnvironments(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllApisPublicViewable(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setPortalUrlPrefix(value);
      break;
    case 17:
      var value = new proto.portal.gloo.solo.io.PortalSpec.GatewayConfig;
      reader.readMessage(value,proto.portal.gloo.solo.io.PortalSpec.GatewayConfig.deserializeBinaryFromReader);
      msg.setGatewayConfig(value);
      break;
    case 18:
      var value = msg.getPageExtensionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.portal.gloo.solo.io.PortalSpec.PageExtension.deserializeBinaryFromReader, "");
         });
      break;
    case 19:
      var value = new github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_pb.RouteOptions;
      reader.readMessage(value,github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_pb.RouteOptions.deserializeBinaryFromReader);
      msg.setRouteOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.PortalSpec.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.PortalSpec} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.PortalSpec.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDomainsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getPrimaryLogo();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.serializeBinaryToWriter
    );
  }
  f = message.getFavicon();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.serializeBinaryToWriter
    );
  }
  f = message.getBanner();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.serializeBinaryToWriter
    );
  }
  f = message.getCustomStyling();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.portal.gloo.solo.io.CustomStyling.serializeBinaryToWriter
    );
  }
  f = message.getStaticPagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.portal.gloo.solo.io.PageSpec.serializeBinaryToWriter
    );
  }
  f = message.getDynamicPagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.portal.gloo.solo.io.PageSpec.serializeBinaryToWriter
    );
  }
  f = message.getEnableIngress();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getOidcAuth();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.portal.gloo.solo.io.PortalSpec.OidcAuth.serializeBinaryToWriter
    );
  }
  f = message.getOauth2Auth();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.serializeBinaryToWriter
    );
  }
  f = message.getTls();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_v1_ssl_ssl_pb.SslConfig.serializeBinaryToWriter
    );
  }
  f = message.getPublishedEnvironmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.serializeBinaryToWriter
    );
  }
  f = message.getAllApisPublicViewable();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getPortalUrlPrefix();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getGatewayConfig();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.portal.gloo.solo.io.PortalSpec.GatewayConfig.serializeBinaryToWriter
    );
  }
  f = message.getPageExtensionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(18, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.portal.gloo.solo.io.PortalSpec.PageExtension.serializeBinaryToWriter);
  }
  f = message.getRouteOptions();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_pb.RouteOptions.serializeBinaryToWriter
    );
  }
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.repeatedFields_, null);
};
goog.inherits(proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.displayName = 'proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    namespace: jspb.Message.getFieldWithDefault(msg, 2, ""),
    apiProductsList: jspb.Message.toObjectList(msg.getApiProductsList(),
    github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector}
 */
proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector;
  return proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector}
 */
proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamespace(value);
      break;
    case 3:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.deserializeBinaryFromReader);
      msg.addApiProducts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNamespace();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getApiProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string namespace = 2;
 * @return {string}
 */
proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.prototype.getNamespace = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.prototype.setNamespace = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated common.portal.gloo.solo.io.ObjectRef api_products = 3;
 * @return {!Array<!proto.common.portal.gloo.solo.io.ObjectRef>}
 */
proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.prototype.getApiProductsList = function() {
  return /** @type{!Array<!proto.common.portal.gloo.solo.io.ObjectRef>} */ (
    jspb.Message.getRepeatedWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef, 3));
};


/** @param {!Array<!proto.common.portal.gloo.solo.io.ObjectRef>} value */
proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.prototype.setApiProductsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.common.portal.gloo.solo.io.ObjectRef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.portal.gloo.solo.io.ObjectRef}
 */
proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.prototype.addApiProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.common.portal.gloo.solo.io.ObjectRef, opt_index);
};


proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector.prototype.clearApiProductsList = function() {
  this.setApiProductsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.portal.gloo.solo.io.PortalSpec.OidcAuth.repeatedFields_, null);
};
goog.inherits(proto.portal.gloo.solo.io.PortalSpec.OidcAuth, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.PortalSpec.OidcAuth.displayName = 'proto.portal.gloo.solo.io.PortalSpec.OidcAuth';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.PortalSpec.OidcAuth.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.PortalSpec.OidcAuth} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.toObject = function(includeInstance, msg) {
  var f, obj = {
    issuer: jspb.Message.getFieldWithDefault(msg, 1, ""),
    clientId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    clientSecret: (f = msg.getClientSecret()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.SecretRef.toObject(includeInstance, f),
    groupClaimKey: jspb.Message.getFieldWithDefault(msg, 4, ""),
    defaultGroupsList: jspb.Message.toObjectList(msg.getDefaultGroupsList(),
    github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.toObject, includeInstance),
    additionalScopesList: jspb.Message.getRepeatedField(msg, 6),
    caCerts: (f = msg.getCaCerts()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.SecretRef.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.PortalSpec.OidcAuth}
 */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.PortalSpec.OidcAuth;
  return proto.portal.gloo.solo.io.PortalSpec.OidcAuth.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.PortalSpec.OidcAuth} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.PortalSpec.OidcAuth}
 */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIssuer(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientId(value);
      break;
    case 3:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.SecretRef;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.SecretRef.deserializeBinaryFromReader);
      msg.setClientSecret(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupClaimKey(value);
      break;
    case 5:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.deserializeBinaryFromReader);
      msg.addDefaultGroups(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addAdditionalScopes(value);
      break;
    case 7:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.SecretRef;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.SecretRef.deserializeBinaryFromReader);
      msg.setCaCerts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.PortalSpec.OidcAuth.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.PortalSpec.OidcAuth} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssuer();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClientSecret();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.SecretRef.serializeBinaryToWriter
    );
  }
  f = message.getGroupClaimKey();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDefaultGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.serializeBinaryToWriter
    );
  }
  f = message.getAdditionalScopesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getCaCerts();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.SecretRef.serializeBinaryToWriter
    );
  }
};


/**
 * optional string issuer = 1;
 * @return {string}
 */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.getIssuer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.setIssuer = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string client_id = 2;
 * @return {string}
 */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.setClientId = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional common.portal.gloo.solo.io.SecretRef client_secret = 3;
 * @return {?proto.common.portal.gloo.solo.io.SecretRef}
 */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.getClientSecret = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.SecretRef} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.SecretRef, 3));
};


/** @param {?proto.common.portal.gloo.solo.io.SecretRef|undefined} value */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.setClientSecret = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.clearClientSecret = function() {
  this.setClientSecret(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.hasClientSecret = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string group_claim_key = 4;
 * @return {string}
 */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.getGroupClaimKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.setGroupClaimKey = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated common.portal.gloo.solo.io.ObjectRef default_groups = 5;
 * @return {!Array<!proto.common.portal.gloo.solo.io.ObjectRef>}
 */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.getDefaultGroupsList = function() {
  return /** @type{!Array<!proto.common.portal.gloo.solo.io.ObjectRef>} */ (
    jspb.Message.getRepeatedWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef, 5));
};


/** @param {!Array<!proto.common.portal.gloo.solo.io.ObjectRef>} value */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.setDefaultGroupsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.common.portal.gloo.solo.io.ObjectRef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.portal.gloo.solo.io.ObjectRef}
 */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.addDefaultGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.common.portal.gloo.solo.io.ObjectRef, opt_index);
};


proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.clearDefaultGroupsList = function() {
  this.setDefaultGroupsList([]);
};


/**
 * repeated string additional_scopes = 6;
 * @return {!Array<string>}
 */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.getAdditionalScopesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/** @param {!Array<string>} value */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.setAdditionalScopesList = function(value) {
  jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.addAdditionalScopes = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.clearAdditionalScopesList = function() {
  this.setAdditionalScopesList([]);
};


/**
 * optional common.portal.gloo.solo.io.SecretRef ca_certs = 7;
 * @return {?proto.common.portal.gloo.solo.io.SecretRef}
 */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.getCaCerts = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.SecretRef} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.SecretRef, 7));
};


/** @param {?proto.common.portal.gloo.solo.io.SecretRef|undefined} value */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.setCaCerts = function(value) {
  jspb.Message.setWrapperField(this, 7, value);
};


proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.clearCaCerts = function() {
  this.setCaCerts(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.PortalSpec.OidcAuth.prototype.hasCaCerts = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.repeatedFields_, null);
};
goog.inherits(proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.displayName = 'proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.repeatedFields_ = [8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.toObject = function(includeInstance, msg) {
  var f, obj = {
    authUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tokenUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    clientId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    clientSecret: (f = msg.getClientSecret()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.SecretRef.toObject(includeInstance, f),
    groupClaimKey: jspb.Message.getFieldWithDefault(msg, 5, ""),
    usernameClaimKey: jspb.Message.getFieldWithDefault(msg, 6, ""),
    emailClaimKey: jspb.Message.getFieldWithDefault(msg, 7, ""),
    defaultGroupsList: jspb.Message.toObjectList(msg.getDefaultGroupsList(),
    github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.toObject, includeInstance),
    scopesList: jspb.Message.getRepeatedField(msg, 9),
    caCerts: (f = msg.getCaCerts()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.SecretRef.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth}
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth;
  return proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth}
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTokenUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientId(value);
      break;
    case 4:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.SecretRef;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.SecretRef.deserializeBinaryFromReader);
      msg.setClientSecret(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupClaimKey(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsernameClaimKey(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailClaimKey(value);
      break;
    case 8:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.deserializeBinaryFromReader);
      msg.addDefaultGroups(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addScopes(value);
      break;
    case 10:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.SecretRef;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.SecretRef.deserializeBinaryFromReader);
      msg.setCaCerts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuthUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTokenUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getClientSecret();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.SecretRef.serializeBinaryToWriter
    );
  }
  f = message.getGroupClaimKey();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUsernameClaimKey();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEmailClaimKey();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDefaultGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.serializeBinaryToWriter
    );
  }
  f = message.getScopesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getCaCerts();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.SecretRef.serializeBinaryToWriter
    );
  }
};


/**
 * optional string auth_url = 1;
 * @return {string}
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.getAuthUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.setAuthUrl = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string token_url = 2;
 * @return {string}
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.getTokenUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.setTokenUrl = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string client_id = 3;
 * @return {string}
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.setClientId = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional common.portal.gloo.solo.io.SecretRef client_secret = 4;
 * @return {?proto.common.portal.gloo.solo.io.SecretRef}
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.getClientSecret = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.SecretRef} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.SecretRef, 4));
};


/** @param {?proto.common.portal.gloo.solo.io.SecretRef|undefined} value */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.setClientSecret = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.clearClientSecret = function() {
  this.setClientSecret(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.hasClientSecret = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string group_claim_key = 5;
 * @return {string}
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.getGroupClaimKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.setGroupClaimKey = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string username_claim_key = 6;
 * @return {string}
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.getUsernameClaimKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.setUsernameClaimKey = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string email_claim_key = 7;
 * @return {string}
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.getEmailClaimKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.setEmailClaimKey = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated common.portal.gloo.solo.io.ObjectRef default_groups = 8;
 * @return {!Array<!proto.common.portal.gloo.solo.io.ObjectRef>}
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.getDefaultGroupsList = function() {
  return /** @type{!Array<!proto.common.portal.gloo.solo.io.ObjectRef>} */ (
    jspb.Message.getRepeatedWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef, 8));
};


/** @param {!Array<!proto.common.portal.gloo.solo.io.ObjectRef>} value */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.setDefaultGroupsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.common.portal.gloo.solo.io.ObjectRef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.portal.gloo.solo.io.ObjectRef}
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.addDefaultGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.common.portal.gloo.solo.io.ObjectRef, opt_index);
};


proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.clearDefaultGroupsList = function() {
  this.setDefaultGroupsList([]);
};


/**
 * repeated string scopes = 9;
 * @return {!Array<string>}
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.getScopesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/** @param {!Array<string>} value */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.setScopesList = function(value) {
  jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.addScopes = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.clearScopesList = function() {
  this.setScopesList([]);
};


/**
 * optional common.portal.gloo.solo.io.SecretRef ca_certs = 10;
 * @return {?proto.common.portal.gloo.solo.io.SecretRef}
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.getCaCerts = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.SecretRef} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.SecretRef, 10));
};


/** @param {?proto.common.portal.gloo.solo.io.SecretRef|undefined} value */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.setCaCerts = function(value) {
  jspb.Message.setWrapperField(this, 10, value);
};


proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.clearCaCerts = function() {
  this.setCaCerts(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth.prototype.hasCaCerts = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.PortalSpec.GatewayConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.portal.gloo.solo.io.PortalSpec.GatewayConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.PortalSpec.GatewayConfig.displayName = 'proto.portal.gloo.solo.io.PortalSpec.GatewayConfig';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.PortalSpec.GatewayConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.PortalSpec.GatewayConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.PortalSpec.GatewayConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.PortalSpec.GatewayConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    labelsMap: (f = msg.getLabelsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.PortalSpec.GatewayConfig}
 */
proto.portal.gloo.solo.io.PortalSpec.GatewayConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.PortalSpec.GatewayConfig;
  return proto.portal.gloo.solo.io.PortalSpec.GatewayConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.PortalSpec.GatewayConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.PortalSpec.GatewayConfig}
 */
proto.portal.gloo.solo.io.PortalSpec.GatewayConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = msg.getLabelsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.PortalSpec.GatewayConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.PortalSpec.GatewayConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.PortalSpec.GatewayConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.PortalSpec.GatewayConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabelsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * map<string, string> labels = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.portal.gloo.solo.io.PortalSpec.GatewayConfig.prototype.getLabelsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


proto.portal.gloo.solo.io.PortalSpec.GatewayConfig.prototype.clearLabelsMap = function() {
  this.getLabelsMap().clear();
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.PortalSpec.PageExtension = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.portal.gloo.solo.io.PortalSpec.PageExtension, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.PortalSpec.PageExtension.displayName = 'proto.portal.gloo.solo.io.PortalSpec.PageExtension';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.PortalSpec.PageExtension.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.PortalSpec.PageExtension.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.PortalSpec.PageExtension} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.PortalSpec.PageExtension.toObject = function(includeInstance, msg) {
  var f, obj = {
    customHtml: (f = msg.getCustomHtml()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.PortalSpec.PageExtension}
 */
proto.portal.gloo.solo.io.PortalSpec.PageExtension.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.PortalSpec.PageExtension;
  return proto.portal.gloo.solo.io.PortalSpec.PageExtension.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.PortalSpec.PageExtension} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.PortalSpec.PageExtension}
 */
proto.portal.gloo.solo.io.PortalSpec.PageExtension.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.deserializeBinaryFromReader);
      msg.setCustomHtml(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.PortalSpec.PageExtension.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.PortalSpec.PageExtension.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.PortalSpec.PageExtension} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.PortalSpec.PageExtension.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomHtml();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.portal.gloo.solo.io.DataSource custom_html = 1;
 * @return {?proto.common.portal.gloo.solo.io.DataSource}
 */
proto.portal.gloo.solo.io.PortalSpec.PageExtension.prototype.getCustomHtml = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.DataSource} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource, 1));
};


/** @param {?proto.common.portal.gloo.solo.io.DataSource|undefined} value */
proto.portal.gloo.solo.io.PortalSpec.PageExtension.prototype.setCustomHtml = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.portal.gloo.solo.io.PortalSpec.PageExtension.prototype.clearCustomHtml = function() {
  this.setCustomHtml(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.PortalSpec.PageExtension.prototype.hasCustomHtml = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string display_name = 1;
 * @return {string}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PortalSpec.prototype.setDisplayName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PortalSpec.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string domains = 3;
 * @return {!Array<string>}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.getDomainsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.portal.gloo.solo.io.PortalSpec.prototype.setDomainsList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.addDomains = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


proto.portal.gloo.solo.io.PortalSpec.prototype.clearDomainsList = function() {
  this.setDomainsList([]);
};


/**
 * optional common.portal.gloo.solo.io.DataSource primary_logo = 4;
 * @return {?proto.common.portal.gloo.solo.io.DataSource}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.getPrimaryLogo = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.DataSource} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource, 4));
};


/** @param {?proto.common.portal.gloo.solo.io.DataSource|undefined} value */
proto.portal.gloo.solo.io.PortalSpec.prototype.setPrimaryLogo = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.portal.gloo.solo.io.PortalSpec.prototype.clearPrimaryLogo = function() {
  this.setPrimaryLogo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.hasPrimaryLogo = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional common.portal.gloo.solo.io.DataSource favicon = 5;
 * @return {?proto.common.portal.gloo.solo.io.DataSource}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.getFavicon = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.DataSource} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource, 5));
};


/** @param {?proto.common.portal.gloo.solo.io.DataSource|undefined} value */
proto.portal.gloo.solo.io.PortalSpec.prototype.setFavicon = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


proto.portal.gloo.solo.io.PortalSpec.prototype.clearFavicon = function() {
  this.setFavicon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.hasFavicon = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional common.portal.gloo.solo.io.DataSource banner = 6;
 * @return {?proto.common.portal.gloo.solo.io.DataSource}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.getBanner = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.DataSource} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource, 6));
};


/** @param {?proto.common.portal.gloo.solo.io.DataSource|undefined} value */
proto.portal.gloo.solo.io.PortalSpec.prototype.setBanner = function(value) {
  jspb.Message.setWrapperField(this, 6, value);
};


proto.portal.gloo.solo.io.PortalSpec.prototype.clearBanner = function() {
  this.setBanner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.hasBanner = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional CustomStyling custom_styling = 7;
 * @return {?proto.portal.gloo.solo.io.CustomStyling}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.getCustomStyling = function() {
  return /** @type{?proto.portal.gloo.solo.io.CustomStyling} */ (
    jspb.Message.getWrapperField(this, proto.portal.gloo.solo.io.CustomStyling, 7));
};


/** @param {?proto.portal.gloo.solo.io.CustomStyling|undefined} value */
proto.portal.gloo.solo.io.PortalSpec.prototype.setCustomStyling = function(value) {
  jspb.Message.setWrapperField(this, 7, value);
};


proto.portal.gloo.solo.io.PortalSpec.prototype.clearCustomStyling = function() {
  this.setCustomStyling(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.hasCustomStyling = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated PageSpec static_pages = 8;
 * @return {!Array<!proto.portal.gloo.solo.io.PageSpec>}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.getStaticPagesList = function() {
  return /** @type{!Array<!proto.portal.gloo.solo.io.PageSpec>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.portal.gloo.solo.io.PageSpec, 8));
};


/** @param {!Array<!proto.portal.gloo.solo.io.PageSpec>} value */
proto.portal.gloo.solo.io.PortalSpec.prototype.setStaticPagesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.portal.gloo.solo.io.PageSpec=} opt_value
 * @param {number=} opt_index
 * @return {!proto.portal.gloo.solo.io.PageSpec}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.addStaticPages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.portal.gloo.solo.io.PageSpec, opt_index);
};


proto.portal.gloo.solo.io.PortalSpec.prototype.clearStaticPagesList = function() {
  this.setStaticPagesList([]);
};


/**
 * repeated PageSpec dynamic_pages = 9;
 * @return {!Array<!proto.portal.gloo.solo.io.PageSpec>}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.getDynamicPagesList = function() {
  return /** @type{!Array<!proto.portal.gloo.solo.io.PageSpec>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.portal.gloo.solo.io.PageSpec, 9));
};


/** @param {!Array<!proto.portal.gloo.solo.io.PageSpec>} value */
proto.portal.gloo.solo.io.PortalSpec.prototype.setDynamicPagesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.portal.gloo.solo.io.PageSpec=} opt_value
 * @param {number=} opt_index
 * @return {!proto.portal.gloo.solo.io.PageSpec}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.addDynamicPages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.portal.gloo.solo.io.PageSpec, opt_index);
};


proto.portal.gloo.solo.io.PortalSpec.prototype.clearDynamicPagesList = function() {
  this.setDynamicPagesList([]);
};


/**
 * optional google.protobuf.BoolValue enable_ingress = 11;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.getEnableIngress = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 11));
};


/** @param {?proto.google.protobuf.BoolValue|undefined} value */
proto.portal.gloo.solo.io.PortalSpec.prototype.setEnableIngress = function(value) {
  jspb.Message.setWrapperField(this, 11, value);
};


proto.portal.gloo.solo.io.PortalSpec.prototype.clearEnableIngress = function() {
  this.setEnableIngress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.hasEnableIngress = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional OidcAuth oidc_auth = 12;
 * @return {?proto.portal.gloo.solo.io.PortalSpec.OidcAuth}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.getOidcAuth = function() {
  return /** @type{?proto.portal.gloo.solo.io.PortalSpec.OidcAuth} */ (
    jspb.Message.getWrapperField(this, proto.portal.gloo.solo.io.PortalSpec.OidcAuth, 12));
};


/** @param {?proto.portal.gloo.solo.io.PortalSpec.OidcAuth|undefined} value */
proto.portal.gloo.solo.io.PortalSpec.prototype.setOidcAuth = function(value) {
  jspb.Message.setOneofWrapperField(this, 12, proto.portal.gloo.solo.io.PortalSpec.oneofGroups_[0], value);
};


proto.portal.gloo.solo.io.PortalSpec.prototype.clearOidcAuth = function() {
  this.setOidcAuth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.hasOidcAuth = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional Oauth2Auth oauth2_auth = 20;
 * @return {?proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.getOauth2Auth = function() {
  return /** @type{?proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth} */ (
    jspb.Message.getWrapperField(this, proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth, 20));
};


/** @param {?proto.portal.gloo.solo.io.PortalSpec.Oauth2Auth|undefined} value */
proto.portal.gloo.solo.io.PortalSpec.prototype.setOauth2Auth = function(value) {
  jspb.Message.setOneofWrapperField(this, 20, proto.portal.gloo.solo.io.PortalSpec.oneofGroups_[0], value);
};


proto.portal.gloo.solo.io.PortalSpec.prototype.clearOauth2Auth = function() {
  this.setOauth2Auth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.hasOauth2Auth = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional gloo.solo.io.SslConfig tls = 13;
 * @return {?proto.gloo.solo.io.SslConfig}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.getTls = function() {
  return /** @type{?proto.gloo.solo.io.SslConfig} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_v1_ssl_ssl_pb.SslConfig, 13));
};


/** @param {?proto.gloo.solo.io.SslConfig|undefined} value */
proto.portal.gloo.solo.io.PortalSpec.prototype.setTls = function(value) {
  jspb.Message.setWrapperField(this, 13, value);
};


proto.portal.gloo.solo.io.PortalSpec.prototype.clearTls = function() {
  this.setTls(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.hasTls = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * repeated EnvironmentSelector published_environments = 14;
 * @return {!Array<!proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector>}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.getPublishedEnvironmentsList = function() {
  return /** @type{!Array<!proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector, 14));
};


/** @param {!Array<!proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector>} value */
proto.portal.gloo.solo.io.PortalSpec.prototype.setPublishedEnvironmentsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector=} opt_value
 * @param {number=} opt_index
 * @return {!proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.addPublishedEnvironments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.portal.gloo.solo.io.PortalSpec.EnvironmentSelector, opt_index);
};


proto.portal.gloo.solo.io.PortalSpec.prototype.clearPublishedEnvironmentsList = function() {
  this.setPublishedEnvironmentsList([]);
};


/**
 * optional bool all_apis_public_viewable = 15;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.getAllApisPublicViewable = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 15, false));
};


/** @param {boolean} value */
proto.portal.gloo.solo.io.PortalSpec.prototype.setAllApisPublicViewable = function(value) {
  jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional string portal_url_prefix = 16;
 * @return {string}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.getPortalUrlPrefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PortalSpec.prototype.setPortalUrlPrefix = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional GatewayConfig gateway_config = 17;
 * @return {?proto.portal.gloo.solo.io.PortalSpec.GatewayConfig}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.getGatewayConfig = function() {
  return /** @type{?proto.portal.gloo.solo.io.PortalSpec.GatewayConfig} */ (
    jspb.Message.getWrapperField(this, proto.portal.gloo.solo.io.PortalSpec.GatewayConfig, 17));
};


/** @param {?proto.portal.gloo.solo.io.PortalSpec.GatewayConfig|undefined} value */
proto.portal.gloo.solo.io.PortalSpec.prototype.setGatewayConfig = function(value) {
  jspb.Message.setWrapperField(this, 17, value);
};


proto.portal.gloo.solo.io.PortalSpec.prototype.clearGatewayConfig = function() {
  this.setGatewayConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.hasGatewayConfig = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * map<string, PageExtension> page_extensions = 18;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.portal.gloo.solo.io.PortalSpec.PageExtension>}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.getPageExtensionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.portal.gloo.solo.io.PortalSpec.PageExtension>} */ (
      jspb.Message.getMapField(this, 18, opt_noLazyCreate,
      proto.portal.gloo.solo.io.PortalSpec.PageExtension));
};


proto.portal.gloo.solo.io.PortalSpec.prototype.clearPageExtensionsMap = function() {
  this.getPageExtensionsMap().clear();
};


/**
 * optional gloo.solo.io.RouteOptions route_options = 19;
 * @return {?proto.gloo.solo.io.RouteOptions}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.getRouteOptions = function() {
  return /** @type{?proto.gloo.solo.io.RouteOptions} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$apis_api_gloo_gloo_v1_options_pb.RouteOptions, 19));
};


/** @param {?proto.gloo.solo.io.RouteOptions|undefined} value */
proto.portal.gloo.solo.io.PortalSpec.prototype.setRouteOptions = function(value) {
  jspb.Message.setWrapperField(this, 19, value);
};


proto.portal.gloo.solo.io.PortalSpec.prototype.clearRouteOptions = function() {
  this.setRouteOptions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.PortalSpec.prototype.hasRouteOptions = function() {
  return jspb.Message.getField(this, 19) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.PortalStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.portal.gloo.solo.io.PortalStatus.repeatedFields_, null);
};
goog.inherits(proto.portal.gloo.solo.io.PortalStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.PortalStatus.displayName = 'proto.portal.gloo.solo.io.PortalStatus';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.portal.gloo.solo.io.PortalStatus.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.PortalStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.PortalStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.PortalStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.PortalStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    observedGeneration: jspb.Message.getFieldWithDefault(msg, 1, 0),
    state: jspb.Message.getFieldWithDefault(msg, 2, 0),
    reason: jspb.Message.getFieldWithDefault(msg, 3, ""),
    publishUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
    publishedEnvironmentsList: jspb.Message.toObjectList(msg.getPublishedEnvironmentsList(),
    proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.PortalStatus}
 */
proto.portal.gloo.solo.io.PortalStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.PortalStatus;
  return proto.portal.gloo.solo.io.PortalStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.PortalStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.PortalStatus}
 */
proto.portal.gloo.solo.io.PortalStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setObservedGeneration(value);
      break;
    case 2:
      var value = /** @type {!proto.common.portal.gloo.solo.io.State} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublishUrl(value);
      break;
    case 6:
      var value = new proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo;
      reader.readMessage(value,proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.deserializeBinaryFromReader);
      msg.addPublishedEnvironments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.PortalStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.PortalStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.PortalStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.PortalStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getObservedGeneration();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPublishUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPublishedEnvironmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.serializeBinaryToWriter
    );
  }
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.repeatedFields_, null);
};
goog.inherits(proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.displayName = 'proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    namespace: jspb.Message.getFieldWithDefault(msg, 2, ""),
    apiProductsList: jspb.Message.toObjectList(msg.getApiProductsList(),
    github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo}
 */
proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo;
  return proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo}
 */
proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamespace(value);
      break;
    case 3:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.deserializeBinaryFromReader);
      msg.addApiProducts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNamespace();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getApiProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string namespace = 2;
 * @return {string}
 */
proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.prototype.getNamespace = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.prototype.setNamespace = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated common.portal.gloo.solo.io.ObjectRef api_products = 3;
 * @return {!Array<!proto.common.portal.gloo.solo.io.ObjectRef>}
 */
proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.prototype.getApiProductsList = function() {
  return /** @type{!Array<!proto.common.portal.gloo.solo.io.ObjectRef>} */ (
    jspb.Message.getRepeatedWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.ObjectRef, 3));
};


/** @param {!Array<!proto.common.portal.gloo.solo.io.ObjectRef>} value */
proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.prototype.setApiProductsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.common.portal.gloo.solo.io.ObjectRef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.portal.gloo.solo.io.ObjectRef}
 */
proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.prototype.addApiProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.common.portal.gloo.solo.io.ObjectRef, opt_index);
};


proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo.prototype.clearApiProductsList = function() {
  this.setApiProductsList([]);
};


/**
 * optional int64 observed_generation = 1;
 * @return {number}
 */
proto.portal.gloo.solo.io.PortalStatus.prototype.getObservedGeneration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.portal.gloo.solo.io.PortalStatus.prototype.setObservedGeneration = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional common.portal.gloo.solo.io.State state = 2;
 * @return {!proto.common.portal.gloo.solo.io.State}
 */
proto.portal.gloo.solo.io.PortalStatus.prototype.getState = function() {
  return /** @type {!proto.common.portal.gloo.solo.io.State} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.common.portal.gloo.solo.io.State} value */
proto.portal.gloo.solo.io.PortalStatus.prototype.setState = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string reason = 3;
 * @return {string}
 */
proto.portal.gloo.solo.io.PortalStatus.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PortalStatus.prototype.setReason = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string publish_url = 4;
 * @return {string}
 */
proto.portal.gloo.solo.io.PortalStatus.prototype.getPublishUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PortalStatus.prototype.setPublishUrl = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated EnvironmentInfo published_environments = 6;
 * @return {!Array<!proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo>}
 */
proto.portal.gloo.solo.io.PortalStatus.prototype.getPublishedEnvironmentsList = function() {
  return /** @type{!Array<!proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo, 6));
};


/** @param {!Array<!proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo>} value */
proto.portal.gloo.solo.io.PortalStatus.prototype.setPublishedEnvironmentsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo}
 */
proto.portal.gloo.solo.io.PortalStatus.prototype.addPublishedEnvironments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.portal.gloo.solo.io.PortalStatus.EnvironmentInfo, opt_index);
};


proto.portal.gloo.solo.io.PortalStatus.prototype.clearPublishedEnvironmentsList = function() {
  this.setPublishedEnvironmentsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.CustomStyling = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.portal.gloo.solo.io.CustomStyling, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.CustomStyling.displayName = 'proto.portal.gloo.solo.io.CustomStyling';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.CustomStyling.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.CustomStyling.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.CustomStyling} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.CustomStyling.toObject = function(includeInstance, msg) {
  var f, obj = {
    primaryColor: jspb.Message.getFieldWithDefault(msg, 1, ""),
    secondaryColor: jspb.Message.getFieldWithDefault(msg, 2, ""),
    backgroundColor: jspb.Message.getFieldWithDefault(msg, 3, ""),
    navigationLinksColorOverride: jspb.Message.getFieldWithDefault(msg, 4, ""),
    buttonColorOverride: jspb.Message.getFieldWithDefault(msg, 5, ""),
    defaultTextColor: jspb.Message.getFieldWithDefault(msg, 6, ""),
    cssStylesheet: (f = msg.getCssStylesheet()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.CustomStyling}
 */
proto.portal.gloo.solo.io.CustomStyling.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.CustomStyling;
  return proto.portal.gloo.solo.io.CustomStyling.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.CustomStyling} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.CustomStyling}
 */
proto.portal.gloo.solo.io.CustomStyling.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrimaryColor(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondaryColor(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBackgroundColor(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNavigationLinksColorOverride(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setButtonColorOverride(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultTextColor(value);
      break;
    case 7:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.deserializeBinaryFromReader);
      msg.setCssStylesheet(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.CustomStyling.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.CustomStyling.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.CustomStyling} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.CustomStyling.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrimaryColor();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSecondaryColor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBackgroundColor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNavigationLinksColorOverride();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getButtonColorOverride();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDefaultTextColor();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCssStylesheet();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.serializeBinaryToWriter
    );
  }
};


/**
 * optional string primary_color = 1;
 * @return {string}
 */
proto.portal.gloo.solo.io.CustomStyling.prototype.getPrimaryColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.CustomStyling.prototype.setPrimaryColor = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string secondary_color = 2;
 * @return {string}
 */
proto.portal.gloo.solo.io.CustomStyling.prototype.getSecondaryColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.CustomStyling.prototype.setSecondaryColor = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string background_color = 3;
 * @return {string}
 */
proto.portal.gloo.solo.io.CustomStyling.prototype.getBackgroundColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.CustomStyling.prototype.setBackgroundColor = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string navigation_links_color_override = 4;
 * @return {string}
 */
proto.portal.gloo.solo.io.CustomStyling.prototype.getNavigationLinksColorOverride = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.CustomStyling.prototype.setNavigationLinksColorOverride = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string button_color_override = 5;
 * @return {string}
 */
proto.portal.gloo.solo.io.CustomStyling.prototype.getButtonColorOverride = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.CustomStyling.prototype.setButtonColorOverride = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string default_text_color = 6;
 * @return {string}
 */
proto.portal.gloo.solo.io.CustomStyling.prototype.getDefaultTextColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.CustomStyling.prototype.setDefaultTextColor = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional common.portal.gloo.solo.io.DataSource css_stylesheet = 7;
 * @return {?proto.common.portal.gloo.solo.io.DataSource}
 */
proto.portal.gloo.solo.io.CustomStyling.prototype.getCssStylesheet = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.DataSource} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource, 7));
};


/** @param {?proto.common.portal.gloo.solo.io.DataSource|undefined} value */
proto.portal.gloo.solo.io.CustomStyling.prototype.setCssStylesheet = function(value) {
  jspb.Message.setWrapperField(this, 7, value);
};


proto.portal.gloo.solo.io.CustomStyling.prototype.clearCssStylesheet = function() {
  this.setCssStylesheet(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.CustomStyling.prototype.hasCssStylesheet = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.portal.gloo.solo.io.PageSpec = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.portal.gloo.solo.io.PageSpec, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.portal.gloo.solo.io.PageSpec.displayName = 'proto.portal.gloo.solo.io.PageSpec';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.portal.gloo.solo.io.PageSpec.prototype.toObject = function(opt_includeInstance) {
  return proto.portal.gloo.solo.io.PageSpec.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.portal.gloo.solo.io.PageSpec} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.PageSpec.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    path: jspb.Message.getFieldWithDefault(msg, 3, ""),
    navigationLinkName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    displayOnHomepage: jspb.Message.getFieldWithDefault(msg, 6, false),
    content: (f = msg.getContent()) && github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.portal.gloo.solo.io.PageSpec}
 */
proto.portal.gloo.solo.io.PageSpec.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.portal.gloo.solo.io.PageSpec;
  return proto.portal.gloo.solo.io.PageSpec.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.portal.gloo.solo.io.PageSpec} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.portal.gloo.solo.io.PageSpec}
 */
proto.portal.gloo.solo.io.PageSpec.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNavigationLinkName(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisplayOnHomepage(value);
      break;
    case 5:
      var value = new github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource;
      reader.readMessage(value,github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.deserializeBinaryFromReader);
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.portal.gloo.solo.io.PageSpec.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.portal.gloo.solo.io.PageSpec.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.portal.gloo.solo.io.PageSpec} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.portal.gloo.solo.io.PageSpec.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNavigationLinkName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDisplayOnHomepage();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getContent();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.portal.gloo.solo.io.PageSpec.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PageSpec.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.portal.gloo.solo.io.PageSpec.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PageSpec.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string path = 3;
 * @return {string}
 */
proto.portal.gloo.solo.io.PageSpec.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PageSpec.prototype.setPath = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string navigation_link_name = 4;
 * @return {string}
 */
proto.portal.gloo.solo.io.PageSpec.prototype.getNavigationLinkName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.portal.gloo.solo.io.PageSpec.prototype.setNavigationLinkName = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool display_on_homepage = 6;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.portal.gloo.solo.io.PageSpec.prototype.getDisplayOnHomepage = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 6, false));
};


/** @param {boolean} value */
proto.portal.gloo.solo.io.PageSpec.prototype.setDisplayOnHomepage = function(value) {
  jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional common.portal.gloo.solo.io.DataSource content = 5;
 * @return {?proto.common.portal.gloo.solo.io.DataSource}
 */
proto.portal.gloo.solo.io.PageSpec.prototype.getContent = function() {
  return /** @type{?proto.common.portal.gloo.solo.io.DataSource} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_dev$portal_api_dev$portal_v1beta1_common_common_pb.DataSource, 5));
};


/** @param {?proto.common.portal.gloo.solo.io.DataSource|undefined} value */
proto.portal.gloo.solo.io.PageSpec.prototype.setContent = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


proto.portal.gloo.solo.io.PageSpec.prototype.clearContent = function() {
  this.setContent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.portal.gloo.solo.io.PageSpec.prototype.hasContent = function() {
  return jspb.Message.getField(this, 5) != null;
};


goog.object.extend(exports, proto.portal.gloo.solo.io);
